
import {markRaw} from 'vue'
import TrackerSegment from 'pages/pulse/tracker/tracker-segment.vue'
import TrackerButtongroup from 'pages/pulse/tracker/tracker-buttongroup.vue'
import TrackerTextarea from 'pages/pulse/tracker/tracker-textarea.vue'
import {COMPANY_ALERTS, TOPIC_SENSITIVITY} from 'consts/tracker'

export default {
  components: {TrackerSegment, TrackerButtongroup, TrackerTextarea},
  emits: ['submit'],
  data() {
    return {
      id: undefined,
      name: undefined,
      ALERTS: markRaw(COMPANY_ALERTS),
      SENSITIVITY: markRaw(TOPIC_SENSITIVITY),
      tracker_focus: 'balanced',
      tracker_alerts: 'all',
      focus_on: undefined,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return !this.loading
    }
  },
  methods: {
    open(topic){
      this.id = topic.id
      this.name = topic.name
      this.tracker_focus = topic.tracker_focus
      this.tracker_alerts = topic.tracker_alerts
      this.focus_on = topic.focus_on
      this.loading = false
      this.$refs.modal.open()
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
    },
    submit() {
      this.loading = true
      this.$emit('submit', {
        id: this.id,
        tracker_focus: this.tracker_focus,
        tracker_alerts: this.tracker_alerts,
        focus_on: this.focus_on,
      })
    }
  }
}
